import styles from "./ToggleSwitch.module.css";

const ToggleSwitch = ({
    checked,
    setToggle,
    disabled = false,
    zoom = 0.6,
}: {
    disabled: boolean;
    checked: boolean;
    setToggle?: any;
    zoom?: number;
}) => {
    return (
        <label
            className={`${styles.switch} ${disabled && styles.disabled}`}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setToggle(e);
            }}
            style={{ zoom }}
        >
            <input type="checkbox" checked={checked} disabled={disabled} />
            <span className={disabled ? undefined : styles.slider}></span>
        </label>
    );
};

export default ToggleSwitch;
